import { Plan } from '../plan';

export class Sowo extends Plan {
    public static readonly PLAN_TYPE = 'plan_sowo';
    public static readonly COVER_URL = 'assets/images/plans/sowo/cover_desktop-sowo.jpg';
    public static readonly COVER_URL_MOBILE = 'assets/images/plans/sowo/cover_mobile-sowo.jpg';

    /* protected updateIncitation() {

        let allClientPromos: IPromotions[] = [];

        if (this.convergence) {
            allClientPromos = allClientPromos.concat(this.convergence);
        }
        if (this.customer) {
            allClientPromos = allClientPromos.concat(this.customer);
        }

        if (this.customerContext === null || this.customerContext.isPremiumForPromo() || this.customerContext.isStandardForPromo() ) {
            this.hasIncitation = allClientPromos.filter((promo: IPromotions) => {
                //@TODO: Since incitation concerns Prospect & Customer this is not true
                // (promo.conditions.acquisition !== null || promo.conditions.client)
                return (promo.conditions.client !== null && promo.conditions.client.incitation.enabled);
            }).length > 0;
        }

        this.hasContract = allClientPromos
            .filter((promo: IPromotions) =>  promo.conditions.callOperator ? true :  promo.conditions.client.contrats.indexOf('ALL') === -1)
            .filter((promo: IPromotions) => {
                return promo.conditions.callOperator || (promo.conditions.client !== null && promo.hasContractType);
            }).length === allClientPromos.length && allClientPromos.length > 0;

        this.isDiscountPrice = this.hasContract || allClientPromos.filter((promo: IPromotions) => {
            if (promo.conditions.callOperator) {
                this.forcedCustomerPromo = this.configService.getData()?.global?.convergence_lot_2.status;
            }
            return (promo.conditions.client !== null && promo.hasContractType) || this.forcedCustomerPromo;
        }).length === allClientPromos.length;

        this.isMainPrice = (this.customerContext == null || (this.priceClient > 0));
    }*/
}
